import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Collapse from "@/components/Collapse";
import { Pill } from "@/components/perf";
import { Lock, Unlock, Medal } from "lucide-react";

const LVL_META = {
  regional: { name: "Regional", color: "#22D3EE" },
  state: { name: "State", color: "#F59E0B" },
  national: { name: "National", color: "#F87171" },
};

export default function GateProgress() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/player/gate-progress").then(({ data }) => setData(data)).catch(() => {});
  }, []);
  if (!data?.levels?.length) return null;
  const unlocked = data.levels.filter((l) => l.unlocked).length;
  return (
    <Collapse title="Entry Gates · Road to Nationals" icon={Medal} testid="gate-progress-toggle"
      badge={<Pill color={unlocked === data.levels.length ? "#4ADE80" : "#F59E0B"}>{unlocked}/{data.levels.length} unlocked</Pill>}
      subtitle="Regional, State and National events require earned access — here's exactly how close you are to each unlock. Win matches to raise PSI, play tournaments, and land a podium to open every door.">
      <div className="grid md:grid-cols-3 gap-4" data-testid="gate-progress-grid">
        {data.levels.map((l) => {
          const meta = LVL_META[l.level] || { name: l.level, color: "#22D3EE" };
          return (
            <div key={l.level} data-testid={`gate-level-${l.level}`}
              className={`border p-4 ${l.unlocked ? "border-green-500/50 bg-green-500/[0.06]" : "border-pb-border bg-pb-surface"}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="font-display font-black uppercase text-lg" style={{ color: meta.color }}>{meta.name}</span>
                {l.unlocked
                  ? <span className="flex items-center gap-1 text-[9px] font-black uppercase tracking-widest text-green-400" data-testid={`gate-unlocked-${l.level}`}><Unlock className="w-3 h-3" /> Unlocked</span>
                  : <span className="flex items-center gap-1 text-[9px] font-black uppercase tracking-widest text-zinc-500" data-testid={`gate-locked-${l.level}`}><Lock className="w-3 h-3" /> Locked</span>}
              </div>
              <div className="space-y-3">
                {l.requirements.map((r, i) => (
                  <div key={i} data-testid={`gate-req-${l.level}-${i}`}>
                    <div className="flex justify-between items-baseline text-[10px] uppercase tracking-widest mb-1">
                      <span className={r.met ? "text-green-400 font-bold" : "text-zinc-400"}>{r.label}{r.met ? " ✓" : ""}</span>
                      <span className="font-mono text-zinc-500">{r.have} / {r.need}</span>
                    </div>
                    <div className="h-1.5 bg-pb-elevated border border-pb-border/60 overflow-hidden">
                      <div className="h-full transition-all duration-700"
                        style={{ width: `${r.pct}%`, background: r.met ? "#4ADE80" : meta.color }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Collapse>
  );
}
